"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Accessor_1 = require("../../models/Accessor");
exports.getComparisonFeatures = function (features) {
    // tslint:disable-next-line:no-any
    return features.comparison;
};
exports.buildComparisonMeasureAccessor = function (effectiveDefinition) {
    var _a;
    var comparison = exports.getComparisonFeatures(effectiveDefinition.features);
    if (!((_a = comparison) === null || _a === void 0 ? void 0 : _a.length)) {
        return undefined;
    }
    return Accessor_1.accessorForReference(comparison[0].measure);
};
exports.buildComparisonTimestampAccessor = function (effectiveDefinition) {
    var _a;
    var comparison = exports.getComparisonFeatures(effectiveDefinition.features);
    if (!((_a = comparison) === null || _a === void 0 ? void 0 : _a.length)) {
        return undefined;
    }
    return Accessor_1.accessorForReference(comparison[0].timestamp);
};
//# sourceMappingURL=index.js.map